import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import ReactPixel from 'meta-pixel';
interface GoldButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  fullWidth?: boolean;
  className?: string;
}
export function GoldButton({
  children,
  fullWidth = false,
  className = '',
  ...props
}: GoldButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout');
    }
    window.open('https://propositodiario.com/cart/42884987781183:1', '_blank');
    props.onClick?.(e);
  };
  return <motion.button whileHover={{
    scale: 1.02,
    backgroundColor: '#B8944F'
  }} whileTap={{
    scale: 0.98
  }} className={`
        bg-[#C9A96E] text-[#1B2141] font-bold py-4 px-8 rounded-lg 
        shadow-lg hover:shadow-xl transition-all duration-300
        text-lg md:text-xl flex items-center justify-center gap-2
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} {...props} onClick={handleClick} data-id="element-198">
      {children}
      <ArrowRight className="w-5 h-5 ml-1" data-id="element-199" />
    </motion.button>;
}